import { createValidationSchema, validate, validateIfFile } from "@";
import type { ThemeFormValues } from "../types";

export const schema = createValidationSchema({
  title: validate("req"),
  themeContent: validate("req"),
  thumbnail: validateIfFile("nullable-image", "thumbnailUrl"),
});

export const defaultValues: Partial<ThemeFormValues> = {
  title: "",
  themeContent: "",
  thumbnail: null,
  thumbnailUrl: null,
};
